import { useBreadcrumb } from "core/features/breadcrumbs";
import ContentExecucaoOrcamentaria from "./components/ContentExecucaoOrcamentaria";

function ExecucaoOrcamentariaListagemPage() {
  useBreadcrumb([
    { name: "Financeiro" },
    {
      url: "/financeiro/execucao-orcamentaria",
      name: "Execução Orçamentária",
    },
  ]);

  return (
    <>
      <ContentExecucaoOrcamentaria />
    </>
  );
}

export default ExecucaoOrcamentariaListagemPage;
